function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9196 17.9109V7.82143H23.7598V27.8664L16.0249 7.82143H16.0794L19.9196 17.9109Z",
  fill: "#9F201C"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.0795 17.967V28.1788H12.2397V8.28604L16.0795 17.967Z",
  fill: "#9F201C"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.76 27.8664V28.1789H20.1301L16.4505 18.902L16.0795 17.9104V17.9671L12.2397 8.28617V7.82143H16.0251L23.76 27.8664Z",
  fill: "#ED0000"
});

var SvgSourceNetflix = function SvgSourceNetflix(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceNetflix, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_netflix.39ef3c2c.svg";
export { ForwardRef as ReactComponent };